module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_ix",
      "title": "ix"
    }
  }, [_vm._v("“The story reveals the meaning of what would remain an unbearable sequence of sheer happenings.”")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEPC1"
  }, [_vm._v("—H"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ANNAH")]), _vm._v(" A"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("RENDT")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_vm._v("“Shit happens.”")]), _vm._v(" "), _c('p', {
    staticClass: "FMEPC"
  }, [_vm._v("—"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ANONYMOUS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efe7073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0